import React from 'react';

export interface FormattedMoneyProps {
  amount: number;
  hideCentsIfZero?: boolean;
  currencySign?: 'standard' | 'accounting';
}

export const formatMoney = ({
  amount,
  hideCentsIfZero = true,
  currencySign = 'standard',
}: FormattedMoneyProps) => {
  const hasCents = amount % 1 !== 0;
  const fractionDigits = !hasCents && hideCentsIfZero ? 0 : 2;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

  // Unlike Intl's accounting currencySign, keep the minus sign inside the
  // parentheses: ($-208.09).
  if (currencySign === 'accounting' && amount < 0) {
    return `(${formatter.format(-amount).replace('$', '$-')})`;
  }
  return formatter.format(amount);
};

export function FormattedMoney({
  amount,
  hideCentsIfZero = true,
  currencySign = 'standard',
}: FormattedMoneyProps) {
  return <>{formatMoney({ amount, hideCentsIfZero, currencySign })}</>;
}
